import { makeStyles } from '@material-ui/core/styles'
import { CONTROL_VARIANT } from './ControlledSlider.const'

const useStyles = makeStyles(
	theme => ({
		control: {
			width: '100%',
			display: 'flex',
			alignItems: 'center',
		},

		dots: {
			textAlign: 'start !important',
			bottom: 'unset !important',
			display: 'flex !important',
			alignItems: 'center !important',
			height: `${theme.spacing(3.25)} !important`,
			width: `${theme.spacing(2)} !important`,
			left: ({ controlVariant }) => (controlVariant === CONTROL_VARIANT.CENTERED ? '50%' : theme.spacing(5.5)),
			justifyContent: 'center',
			gap: theme.spacing(0.2),

			[theme.breakpoints.down('xs')]: {
				left: 'unset',
			},

			'& li': {
				margin: '0 !important',
				height: 'inherit !important',
				width: 'inherit !important',
			},

			'& li button': {
				height: 'inherit !important',
				width: 'inherit !important',
			},

			'& li button:before': {
				fontSize: `${theme.spacing(1)} !important`,
				height: `${theme.spacing(1)} !important`,
				lineHeight: `${theme.spacing(3.25)} !important`,
				width: `${theme.spacing(1)} !important`,
				backgroundColor: `${theme.palette.text.primary} !important`,
				borderRadius: '50%',
				content: '"" !important',
				top: '50% !important',
				left: '50% !important',
				transform: 'translate(-50%, -50%)',
				color: `${theme.palette.text.primary} !important`,
			},
		},

		[CONTROL_VARIANT.WIDE]: {
			'& $control': {
				justifyContent: 'flex-end',
			},

			'& $button': {
				border: `1px solid ${theme.palette.text.secondary}`,
				width: theme.spacing(3),
				height: theme.spacing(3),
				color: theme.palette.text.secondary,
				fontSize: theme.spacing(1),
				margin: `0 ${theme.spacing(1)}`,
			},

			'& $button $icon': {
				fontSize: theme.spacing(2),
				color: theme.palette.text.secondary,
			},
		},

		[CONTROL_VARIANT.CENTERED]: {
			'& $control': {
				justifyContent: 'space-between',
				padding: `0 ${theme.spacing(3.75)}`,
			},

			'& $button': {
				width: theme.spacing(3),
				height: theme.spacing(3),
				fontSize: theme.spacing(3),
				color: theme.palette.text.secondary,
				margin: 0,
			},

			'& $button $icon': {
				fontSize: theme.spacing(3),
				color: theme.palette.text.secondary,
			},
		},

		icon: {},
		button: {},
	}),
	{ name: 'ControlledSlider' },
)

export default useStyles
